<!--页面底部的备案-->
<template>
    <div style="text-align: center">
      <div style="margin-bottom:15px;color: #9b9b9f;font-size: 15px" >沪ICP备20010476号-2. Powered by VGsoft Team. All rights reserved. Live Statistics</div>
    </div>
</template>

<script>
export default {
  name: "Footers"
}
</script>

<style scoped>

</style>
